export * from './admin-business-premises-api-client.service';
import { AdminBusinessPremisesApiClient } from './admin-business-premises-api-client.service';
export * from './admin-business-premises-api-client.serviceInterface';
export * from './admin-contracts-api-client.service';
import { AdminContractsApiClient } from './admin-contracts-api-client.service';
export * from './admin-contracts-api-client.serviceInterface';
export * from './admin-delete-api-client.service';
import { AdminDeleteApiClient } from './admin-delete-api-client.service';
export * from './admin-delete-api-client.serviceInterface';
export * from './admin-eric-validation-api-client.service';
import { AdminEricValidationApiClient } from './admin-eric-validation-api-client.service';
export * from './admin-eric-validation-api-client.serviceInterface';
export * from './admin-fcc-versions-api-client.service';
import { AdminFccVersionsApiClient } from './admin-fcc-versions-api-client.service';
export * from './admin-fcc-versions-api-client.serviceInterface';
export * from './admin-initialize-api-client.service';
import { AdminInitializeApiClient } from './admin-initialize-api-client.service';
export * from './admin-initialize-api-client.serviceInterface';
export * from './admin-organizations-api-client.service';
import { AdminOrganizationsApiClient } from './admin-organizations-api-client.service';
export * from './admin-organizations-api-client.serviceInterface';
export * from './admin-status-log-api-client.service';
import { AdminStatusLogApiClient } from './admin-status-log-api-client.service';
export * from './admin-status-log-api-client.serviceInterface';
export * from './admin-tenants-api-client.service';
import { AdminTenantsApiClient } from './admin-tenants-api-client.service';
export * from './admin-tenants-api-client.serviceInterface';
export * from './admin-tss-api-client.service';
import { AdminTssApiClient } from './admin-tss-api-client.service';
export * from './admin-tss-api-client.serviceInterface';
export * from './auth-keys-api-client.service';
import { AuthKeysApiClient } from './auth-keys-api-client.service';
export * from './auth-keys-api-client.serviceInterface';
export const APIS = [AdminBusinessPremisesApiClient, AdminContractsApiClient, AdminDeleteApiClient, AdminEricValidationApiClient, AdminFccVersionsApiClient, AdminInitializeApiClient, AdminOrganizationsApiClient, AdminStatusLogApiClient, AdminTenantsApiClient, AdminTssApiClient, AuthKeysApiClient];
